module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoBAMAAAB+0KVeAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAqUExURUdwTPtmIPtmIPtmIPtmIPtmIPtmIPtmIP/q4P2pgv/+/fyBR/yYaf7Ruw9gVQYAAAAHdFJOUwDgWAWsj3PZ6IXkAAAACXBIWXMAAABIAAAASABGyWs+AAAA0klEQVQoz23RwQ2CMBTG8W8GXcARnMEVnASjqQl6Voj3lzCBFD2TmHgGXcAElxHahzzo66Xhlz+8puAcrgQKkoKJUZAUTIyCpGAbhkgKdmGApKALp0gK+nCCpCCHYyQF+3CEpOA/lOjDupTIoa0k+vB4l69z+Cgk8ujmI5DDw1VO53CfC+zPmJ0EtuGrfYptOWAXpjkfqMfui097Me9iQP/F2n5T8Tt4dGbdgUwEMTpubm7fQt5jXLltA3mPvOYQYb8WCMMdEIZrIAhnACZhtFoCP6LklItjkgVqAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/search/search_0.png
// module id = 11
// module chunks = 0